import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { IconButton, Icon, Panel, Modal, CheckboxGroup, Checkbox } from 'rsuite'
import ResultForm from './ResultForm'
import ResultView from './ResultView'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import {
  getIndicators,
  saveIndicators,
  updateIndicators,
  deleteIndicators,
  saveSubProjectIndicators,
  updateSubProjectIndicators,
  getSubProjectIndicators,
  deleteSubProjectIndicators,
  getLinkageIndicators,
  saveLinkageIndicators,
} from '../../../redux/actions/objectiveGoal'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getSchemaSidebar, getSchemaSubProjectSidebar } from '../../../redux/actions/sidebar'
import WarningMessage from '../../../components/message/WarningMessage/WarningMessage'
import ResultConnectionModal from './ResultConnectionModal'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import { getValueFromOptions } from '../../../utils/dataUtil'
import EditButton from '../../../components/buttons/editButton/EditButton'
import notification from '../../../utils/notification'
import { SAVE_SUCCESS_MSG } from '../../../constants/msgText'

export default function ResultWidget({ schema: _schema, onSuccess = () => {}, ...props }) {
  const { showCommandButton, isEdit, onChangeIsEdit, isSubProject, isCoordinator } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [isShowConnection, setIsShowConnection] = useState(false)
  const [indicatorSelectRow, setIndicatorSelectRow] = useState()
  const [connectionSchema, setConnectionSchema] = useState()

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    // console.log('ResultWidget _schema', _schema)
    setFormSchema(_schema)
  }, [_schema])

  const handleUpdateSave = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response
      if (request.id) {
        console.log('call update.')
        response = await updateIndicators(projectId, request.id, request)
      } else {
        console.log('call save.')
        response = await saveIndicators(projectId, request)
      }
      // console.log('call save. request ', request)
      // const response = await saveIndicators(request)

      console.log('response', response)

      if (response) {
        // setFormSchema(response.model.forms.indicator)
        setFormSchema(response)
        onSuccess(response)
        try {
          await dispatch(getSchemaSidebar(projectId))
        } catch (e) {}
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleUpdateSaveSubProject = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response
      if (request.id) {
        console.log('call update.')
        response = await updateSubProjectIndicators(projectId, request.id, request)
      } else {
        console.log('call save.')
        response = await saveSubProjectIndicators(projectId, request)
      }
      // console.log('call save. request ', request)
      // const response = await saveIndicators(request)

      console.log('response', response)

      if (response) {
        // setFormSchema(response.model.forms.indicator)
        setFormSchema(response)
        try {
          await dispatch(getSchemaSubProjectSidebar(projectId))
        } catch (e) {}
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDelete = async (id) => {
    startLoading()
    setIsLoading(true)
    setIsDeleteError(false)
    try {
      console.log('call delete.')
      const status = await deleteIndicators(projectId, id)
      if (status === 200) {
        console.log('call get.')
        const _schema = await getIndicators(projectId)
        console.log(('result', _schema))
        setFormSchema(_schema)
      } else {
        setIsDeleteError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsDeleteError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDeleteSubProject = async (id) => {
    startLoading()
    setIsLoading(true)
    setIsDeleteError(false)
    try {
      console.log('call delete.')
      const status = await deleteSubProjectIndicators(projectId, id)
      if (status === 200) {
        console.log('call get.')
        const _schema = await getSubProjectIndicators(projectId)
        console.log(('result', _schema))
        setFormSchema(_schema)
      } else {
        setIsDeleteError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsDeleteError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleGetConnection = async (rowData) => {
    startLoading()
    setIsLoading(true)
    try {
      var response = await getLinkageIndicators(projectId, rowData.id)
      setConnectionSchema(response)

      setIndicatorSelectRow(rowData)
      setIsShowConnection(true)
    } catch (e) {
      console.log('e', e)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleOnSaveConnection = async (request) => {
    startLoading()
    setIsLoading(true)
    try {
      var response = await saveLinkageIndicators(request, projectId, indicatorSelectRow.id)

      if (response) {
        setIsShowConnection(false)
        setConnectionSchema()
        setIndicatorSelectRow()

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })

        const _schema = await getIndicators(projectId)
        setFormSchema(_schema)
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title:
          e?.response?.data?.errors?.message ||
          'ไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ',
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleAddEdit = async () => {
    let _schema
    if (isSubProject) {
      _schema = await getSubProjectIndicators(projectId)
    } else {
      _schema = await getIndicators(projectId)
    }

    // console.log('handleAddEdit ', JSON.stringify(_schema))

    setFormSchema(_schema)
    onChangeIsEdit(!isEdit)
    scrollToEdtiForm()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    // let indicatorsResult = formSchema?.indicatorsResult?.value || null
    // let id
    // if (data.selectedIndex != -1 && indicatorsResult) {
    //   id = indicatorsResult[data.selectedIndex]?.id
    // }

    let request = {
      id: data.selectedId,
      objective: data.objective,
      objectiveResult: data.objectiveResult,
      indicatorsList: data.indicatorsList,
    }
    // console.log('request', JSON.stringify(request))

    if (isSubProject) {
      handleUpdateSaveSubProject(request)
    } else {
      handleUpdateSave(request)
    }
  }

  const onDelete = (id) => {
    if (isSubProject) {
      handleDeleteSubProject(id)
    } else {
      handleDelete(id)
    }
  }

  const scrollToEdtiForm = () => {
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
  }

  const handleOnSelectConnection = (rowData) => {
    console.log('rowData', rowData)

    handleGetConnection(rowData)
  }

  return (
    <>
      <Panel
        shaded
        header={formSchema.header}
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
        style={{ marginBottom: 15 }}
      >
        <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

        {isEdit && showCommandButton ? (
          <ResultForm
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            onSubmit={handleSubmit(onSubmit)}
            onDelete={onDelete}
            scrollToEdtiForm={scrollToEdtiForm}
            getValues={getValues}
            isError={isError}
            isDeleteError={isDeleteError}
            loading={isLoading}
            onSelectConnection={handleOnSelectConnection}
            isCoordinator={isCoordinator}
            isSubProject={isSubProject}
          />
        ) : (
          <>
            <ResultView schema={formSchema} />
          </>
        )}

        {showCommandButton && (
          <>
            <div style={{ padding: '0 20px 20px 20px' }}>
              <hr />

              {isEdit ? (
                <div>
                  {!isCoordinator && (
                    <IconButton
                      appearance="ghost"
                      className="rs-btn-ghost-info"
                      icon={<Icon className="bt-gost-icon-radius-info" icon="backward" />}
                      onClick={(e) => {
                        onChangeIsEdit(!isEdit)
                        setIsError(false)
                        setIsDeleteError(false)
                        scrollToEdtiForm()
                      }}
                    >
                      {'ดูรายการ' + (formSchema.buttonText ? formSchema.buttonText : '')}
                    </IconButton>
                  )}
                </div>
              ) : (
                <IconButton
                  appearance="ghost"
                  className="rs-btn-ghost-edit"
                  onClick={handleAddEdit}
                  icon={<Icon className="bt-gost-icon-radius-edit" icon="edit" />}
                >
                  {'เพิ่ม/แก้ไข' + (formSchema.buttonText ? formSchema.buttonText : '')}
                </IconButton>
              )}
            </div>
          </>
        )}
      </Panel>

      {indicatorSelectRow && connectionSchema && (
        <ResultConnectionModal
          schema={connectionSchema}
          isShowConnection={isShowConnection}
          setIsShowConnection={(isShow) => {
            console.log('onHide')
            setIsShowConnection(isShow)
            setConnectionSchema()
            setIndicatorSelectRow()
          }}
          indicatorSelectRow={indicatorSelectRow}
          onSubmitData={(request) => handleOnSaveConnection(request)}
        />
      )}
    </>
  )
}
